import React from 'react';
import { Hero } from './components/Hero';
import { EventDetails } from './components/EventDetails';
import { AboutEvening } from './components/AboutEvening';
import { Programme } from './components/Programme';
import { PracticalInfo } from './components/PracticalInfo';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-velvet text-parchment selection:bg-carrot selection:text-white font-sans overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <EventDetails data-id="element-3" />
        <AboutEvening data-id="element-4" />
        <Programme data-id="element-5" />
        <PracticalInfo data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}